export default (intervalsMeta: [number, number][], intervalStep = 0.1) => {
  const intervalsMetaIdxMax = intervalsMeta.length - 1;

  const steps = [];
  const times = [];

  let idx = 0;
  let acc = 0;

  while (intervalsMetaIdxMax - idx >= 0) {
    const [part, time] = intervalsMeta[idx];

    //
    while (part - acc >= 0) {
      steps.push(acc);
      times.push(time);
      acc += intervalStep;
    }

    ++idx;
  }

  return [steps.slice(1), times.slice(1)];
};
